import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import VoucherDetail from "../../components/VoucherDetail/VoucherDetail";
import { AppContext } from "../../contexts/AppContext";

const VoucherDetailPage = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();

  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  return <VoucherDetail />;
};

export default VoucherDetailPage;
